import http from '../utils/request'

/**
 * 邮件系统接口
 * 对应后端 MailController (/api/mail)
 */

// ============ 内部邮件管理 ============

/**
 * 获取收件箱邮件列表
 * @param {Object} params - { pageIndex, pageSize, keyword }
 * @returns {Promise}
 */
export const getInboxMails = (params = {}) => {
  return http.get('/mail/internal/inbox', { params })
}

/**
 * 获取已发送邮件列表
 * @param {Object} params - { pageIndex, pageSize }
 * @returns {Promise}
 */
export const getSentMails = (params = {}) => {
  return http.get('/mail/internal/sent', { params })
}

/**
 * 获取草稿箱邮件列表
 * @param {Object} params - { pageIndex, pageSize }
 * @returns {Promise}
 */
export const getDraftMails = (params = {}) => {
  return http.get('/mail/internal/drafts', { params })
}

/**
 * 获取已删除邮件列表
 * @param {Object} params - { pageIndex, pageSize }
 * @returns {Promise}
 */
export const getTrashMails = (params = {}) => {
  return http.get('/mail/internal/trash', { params })
}

/**
 * 获取邮件详情
 * @param {number} id - 邮件ID
 * @returns {Promise}
 */
export const getMailDetail = (id) => {
  return http.get(`/mail/internal/${id}`)
}

/**
 * 发送邮件
 * @param {Object} data - { toAccount, toName, subject, content }
 * @returns {Promise}
 */
export const sendMail = (data) => {
  return http.post('/mail/internal/send', data)
}

/**
 * 保存草稿
 * @param {Object} data - { id?, toAccount, toName, subject, content }
 * @returns {Promise}
 */
export const saveDraft = (data) => {
  return http.post('/mail/internal/draft', data)
}

/**
 * 删除邮件（移至垃圾箱）
 * @param {string} ids - 邮件ID，多个用逗号分隔
 * @returns {Promise}
 */
export const deleteMails = (ids) => {
  return http.delete(`/mail/internal/${ids}`)
}

/**
 * 标记为已读
 * @param {string} ids - 邮件ID，多个用逗号分隔
 * @returns {Promise}
 */
export const markMailsAsRead = (ids) => {
  return http.put(`/mail/internal/read/${ids}`)
}

/**
 * 获取邮件统计数据
 * @returns {Promise}
 */
export const getMailStats = () => {
  return http.get('/mail/stats')
}
